module.exports = __webpack_public_path__ + "static/media/category.3f93f853.png";